import { useEffect } from 'react';
import { useIconStyles } from './Icon.styles';
import { buildIconAriaProps } from '../iconAriaProps';
import { jsx as _jsx } from "react/jsx-runtime";
const FA_PREFIX = {
  solid: 'fa-solid',
  regular: 'fa-regular',
  brands: 'fa-brands'
};
const FONTAWESOME_LINK_ID = 'interactive-cards-fontawesome';
const FONTAWESOME_CSS_URL = 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.2/css/all.min.css';
export default function Icon({
  name,
  style,
  size,
  color,
  ariaLabel
}) {
  useEffect(() => {
    if (typeof document === 'undefined') return;
    if (!document.getElementById(FONTAWESOME_LINK_ID)) {
      const link = document.createElement('link');
      link.id = FONTAWESOME_LINK_ID;
      link.rel = 'stylesheet';
      link.href = FONTAWESOME_CSS_URL;
      document.head.appendChild(link);
    }
  }, []);
  const {
    style: cssStyle
  } = useIconStyles(size, color);
  const safeName = name.split(/\s/)[0];
  const prefix = FA_PREFIX[style !== null && style !== void 0 ? style : 'solid'];
  return /*#__PURE__*/_jsx("i", Object.assign({
    className: `${prefix} fa-${safeName}`,
    style: cssStyle
  }, buildIconAriaProps(ariaLabel)));
}